import store from '@/store';

export default {
    methods: {
        updateUnreadCount () {
            const conversations = store.state.session_conversations.index_public_unarchived;
            if (!conversations) {
                // Not loaded (e.g. the app was opened on another list, or after a refresh there);
                // keep the last count until the main list is fetched.
                return;
            }

            const newUnreadCount = conversations.reduce((count, conv) => count + (conv.read ? 0 : 1), 0);
            store.commit('unread_count', newUnreadCount);
        },
    },
};
